module.exports = __webpack_public_path__ + "static/media/x.12f7cec7.svg";